$(function() {
  $('.checkboxes-buttons-group').each(function(index, elm) {
    var $group = $(elm)
    var $toggle = $group.find('[data-role="toggle"]')

    $group
      .on('change checkboxgroup:check', function() {
        var $checkboxes = $group.find(':checkbox')
        if ($checkboxes.filter(':checked').length === $checkboxes.length) {
          $toggle.text($toggle.data('text-none'))
        } else {
          $toggle.text($toggle.data('text-all'))
        }
        $('.form-error-message').hide()
      })
      .trigger('checkboxgroup:check')

    $toggle.on('click', function(evt) {
      evt.preventDefault()
      var $checkboxes = $group.find(':checkbox')

      if ($checkboxes.filter(':checked').length === $checkboxes.length) {
        $checkboxes.prop('checked', false).trigger('change')
      } else {
        $checkboxes
          .filter(':not(:checked)')
          .prop('checked', true)
          .trigger('change')
      }
    })
  })
})
